import { useEffect } from "react";
import { createPortal } from "react-dom";

function Modal({ children }: { children: React.ReactElement | React.ReactNode }){
    useEffect(() => {
        const mainSection = document.getElementById('mainSection');
    
        if(mainSection){
          mainSection.inert = true;
        }
    
        return () => {
          if(mainSection){
            mainSection.inert = false;
          }
        }
    }, [])

    return createPortal(children, document.body)
}

export default Modal;